var MobileModeChangeSource;
(function (MobileModeChangeSource) {
  MobileModeChangeSource["User"] = "user";
  MobileModeChangeSource["Browser"] = "browser";
})(MobileModeChangeSource || (MobileModeChangeSource = {}));
var MobileModeChangeSource$1 = MobileModeChangeSource;

export { MobileModeChangeSource$1 as M };
//# sourceMappingURL=MobileModeChangeSource-b30fe130.js.map
